import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a13fcf5c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "c-date-select"
};
var _hoisted_2 = {
  class: "dateSelect flex align-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "left",
    style: _normalizeStyle({
      backgroundColor: _ctx.backgroundColor
    }),
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.preClick && _ctx.preClick.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "18",
    color: "rgba(67, 114, 246, 1)"
  })], 4), _createElementVNode("div", {
    class: "content",
    style: _normalizeStyle({
      backgroundColor: _ctx.backgroundColor
    })
  }, _toDisplayString(_ctx.showDate), 5), _createElementVNode("div", {
    class: "right",
    style: _normalizeStyle({
      backgroundColor: _ctx.backgroundColor
    }),
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.nextClick && _ctx.nextClick.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "arrow",
    size: "18",
    color: "rgba(67, 114, 246, 1)"
  })], 4)])]);
}